import { render, staticRenderFns } from "./SolicitudTorresForm.vue?vue&type=template&id=0d3abe36&scoped=true&"
import script from "./SolicitudTorresForm.vue?vue&type=script&lang=ts&"
export * from "./SolicitudTorresForm.vue?vue&type=script&lang=ts&"
import style0 from "./SolicitudTorresForm.vue?vue&type=style&index=0&id=0d3abe36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3abe36",
  null
  
)

export default component.exports